<!-- Componente utilizado para albergar la lógica de los botnes de accion dentro de las emisiones -->
<template>
    <div>
        <v-expansion-panels style="margin: 20px 0;">
            <v-expansion-panel>
                <v-expansion-panel-header class="text-uppercase" style="font-size: 14px; font-weight: 500;">
                    Acciones
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="3">
                            <p class="acciones-grupo-label">Emisión</p>
                            <div class="acciones-buttons">
                                <BotonAccion label="Aprobación sin código obtenida" icon="mdi-arrow-expand-right"
                                    :tooltip="canEmitOrShowCertificadoState.tooltip"
                                    :disabled="canEmitOrShowCertificadoState.disabled"
                                    @click="abrirValidarSinCodigoCheck" />
                                <BotonAccion label="Enviar y Validar Código SMS" icon="mdi-message-alert"
                                    :tooltip="enviarYValidarCodigoSmsState.tooltip"
                                    :disabled="enviarYValidarCodigoSmsState.disabled"
                                    @click="showConfirmationDialog = true" />
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <p class="acciones-grupo-label">Certificado</p>
                            <div class="acciones-buttons">
                                <BotonAccion label="Obtener Certificado" icon="mdi-certificate"
                                    :tooltip="obtenerCertificadoState.tooltip"
                                    :disabled="obtenerCertificadoState.disabled" @click="abrirObtenerCertificado" />
                                <BotonAccion label="Volver a cotizar WS" icon="mdi-certificate"
                                    :tooltip="cotizarWSState.tooltip" :disabled="cotizarWSState.disabled"
                                    @click="abrirCotizarWs" />
                                <BotonAccion label="Reenviar Certificado" icon="mdi-email-sync-outline"
                                    :tooltip="reenviarCertificadoState.tooltip"
                                    :disabled="reenviarCertificadoState.disabled" @click="abrirReenviarCertificado" />
                                <BotonAccion label="Aplicar endoso" icon="mdi-apple-keyboard-shift"
                                    @click="abrirAplicarEndoso" :tooltip="aplicarEndosoState.tooltip"
                                    :disabled="aplicarEndosoState.disabled" />
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <p class="acciones-grupo-label">Cuotas</p>
                            <div class="acciones-buttons">
                                <BotonAccion label="Generar nuevamente" icon="mdi-auto-fix" @click="abrirGenerarCuotas"
                                    :tooltip="generarCuotasState.tooltip" :disabled="generarCuotasState.disabled" />
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <p class="acciones-grupo-label">Estado</p>
                            <div class="acciones-buttons">
                                <BotonAccion label="Renovar" icon="mdi-crosshairs-gps" @click="abrirRenovacionManual"
                                    :tooltip="renovarPolizaState.tooltip" :disabled="renovarPolizaState.disabled" />
                                <BotonAccion label="Reactivar" icon="mdi-restart" @click="abrirReactivarPoliza"
                                    :tooltip="reactivarPolizaState.tooltip" :disabled="reactivarPolizaState.disabled" />
                                <BotonAccion label="Cancelar" icon="mdi-close-box" @click="abrirCancelacionEmision"
                                    :tooltip="cancelarPolizaState.tooltip" :disabled="cancelarPolizaState.disabled" />
                            </div>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <!-- Este es para enviar y validar codigo sms -->
        <validatePolicyCode v-if="showConfirmationDialog" :show="showConfirmationDialog" :policy="poliza"
            @close="showConfirmationDialog = false" @policySuccess="refreshPage"></validatePolicyCode>
        <ConfirmDialog ref="confirmDialog" />
        <CancelacionDialog ref="cancelacionDialog" :motivosCancelacion="motivosCancelacion"
            :productoAseguradora="producto?.producto_aseguradora" :statusPoliza="poliza?.status"
            :telefonoContacto="poliza?.celular" />
        <AplicarEndosoDialog ref="aplicarEndosoDialog" :poliza="poliza" />
        <RenovacionManualDialog ref="renovacionManualDialog" />
        <FormPolizaCancelacion :poliza="poliza" :active="showCancelacionDialog" v-if="lead && showCancelacionDialog"
            :producto="producto?.producto_lead" :productoAseguradora="producto?.producto_aseguradora"
            :corte="lead?.corte" :identificador="lead?.id" :motivoCancelacion="motivoCancelacion" />


    </div>
</template>


<script>
import { mapState } from "vuex";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import FormPolizaCancelacion from "../../../bradescard/components/documentos/FormPolizaCancelacion.vue";
import RenovacionManualDialog from "../dialogs/RenovacionManualDialog.vue";
import { getStatusEmisionNombre } from "../../../../../constants/index.js";
import { emisionRenovarProductos } from "@/services/renovacionService";
import AplicarEndosoDialog from "../dialogs/AplicarEndosoDialog.vue";
import moment from "moment";
import CancelacionDialog from "../dialogs/CancelacionDialog.vue";
import validatePolicyCode from "@/components/emision/validatePolicyCode.vue";
import BotonAccion from "../../../../components/BotonAccion.vue";

export default {
    name: "AccionesEmision",
    components: {
        validatePolicyCode,
        FormPolizaCancelacion,
        ConfirmDialog,
        AplicarEndosoDialog,
        RenovacionManualDialog,
        CancelacionDialog,
        BotonAccion
    },
    data() {
        return {
            renovatePolicy: false,
            motivoCancelacion: "",
            showCancelacionDialog: false,
            showConfirmationDialog: false,
            roles: JSON.parse(localStorage.getItem("roles")) || [],
            rolName: JSON.parse(localStorage.getItem("roles"))[0].rol || "Desconocido"
        };
    },
    computed: {
        ...mapState("permisos", ["permisos"]),
        enviarYValidarCodigoSmsState() {
            const validaciones = [
                {   // Poliza
                    cumple: this.poliza,
                    mensaje: "Cargando..."
                },
                {   // Status
                    cumple: this.poliza.status == "Emitido el certificado",
                    mensaje: "El status no es válido. Estado actual: " + this.poliza.status
                }
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Emitir póliza con validación por SMS"
            };
        },
        canEmitOrShowCertificadoState() {
            const validaciones = [
                {   // CanEmit - Caso 1
                    cumple: this.poliza?.status === "Emitido el certificado" &&
                        this.rolName !== "AGENTCC" &&
                        this.rolName !== "AGENTCCELITE" &&
                        !this.poliza.validacionCodigo &&
                        this.poliza.globalInteractionId !== "0000",
                },
                {   // CanEmit - Caso 2
                    cumple: this.poliza?.status === "Emitido el certificado" &&
                        this.poliza.validacionCodigo === false &&
                        this.poliza.id === this.poliza.globalInteractionId,
                },
                {   // CanEmit - Caso 3
                    cumple: this.poliza?.status === "Emitido el certificado" &&
                        this.poliza.globalInteractionId === "0000" &&
                        this.lead &&
                        this.lead.operador_id === null,
                },
                {   // ShowCertificado
                    cumple: this.rolName === "ADMIN" &&
                        this.poliza?.status === "Emitida Pendiente de Pago" &&
                        !this.poliza?.certificadoBradescard,
                }
            ];

            const cumpleAlguno = validaciones.some(v => v.cumple);

            return {
                disabled: !cumpleAlguno,
                tooltip: cumpleAlguno ? "Emitir póliza sin código" : "No cumple los requisitos"
            };
        },
        cotizarWSState() {
            if (!this.producto?.etiqueta_aseguradora) {
                return {
                    disabled: true,
                    tooltip: "Producto no disponible"
                };
            }
            const validaciones = [
                {   // Poliza
                    cumple: this.poliza.poliza || this.poliza.poliza == '',
                    mensaje: "La póliza ya tiene un número asignado"
                },
                {   //  Status
                    cumple: this.poliza.status === "Nueva",
                    mensaje: `Estado no válido. Estado actual: ${this.poliza.status}`
                },
                { // Etiqueta Aseguradora
                    cumple: [1, 2, 3, 5].includes(Number(this.producto.etiqueta_aseguradora)),
                    mensaje: "El producto no permite obtener el certificado de esta manera"
                },
            ];
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Cotizar con servicio web"
            };
        },
        obtenerCertificadoState() {
            const validaciones = [
                {   // Poliza
                    cumple: this.poliza.id != null,
                    mensaje: "Cargando..."
                },
                {   // Status
                    cumple: this.poliza.status == "Nueva",
                    mensaje: `El status no es válido. Estado actual: ${this.poliza.status}`
                },
                {   // Producto
                    cumple: !["Hogar", "HOGAR", "Celular", "Hospitalizacion", "Asistencias"].find((productoAseguradora) => productoAseguradora == this.producto?.producto_aseguradora),
                    mensaje: "El producto no permite obtener el certificado de esta manera"
                },
                {   //  Beneficiarios
                    cumple: (this.porcentaje >= 100) && (this.beneficiarios.length <= 5 && this.beneficiarios.length > 0),
                    mensaje: "Debes crear uno o hasta 5 beneficiarios que cubran el 100% de porcentaje de asignación para que se pueda asignar un certificado"
                },
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Obtener certificado"
            };
        },
        reenviarCertificadoState() {
            const validaciones = [
                {   //  Rol
                    cumple: ["ADMIN", "ADMINCC", "OPERADOR", "OPERACIONES", "MANAGERCC", "OPERADORSERVICIOS", "COORDINADOR", "SUPERVISOR", "GERENTE"].includes(this.rolName),
                    mensaje: "No tienes permisos para realizar esta acción."
                },
                {
                    cumple: this.producto?.aseguradoraId == 7,
                    mensaje: "La aseguradora no permite realizar esta acción."
                },
                {   // Status
                    cumple: ["Emitida Pendiente de Pago", "Pagada Parcial", "Pagada Total"].includes(this.poliza?.status),
                    mensaje: this.poliza?.status === "Nueva"
                        ? "La póliza no cuenta con certificado."
                        : "La póliza no se encuentra en status válido para realizar esta acción."
                },
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Reenviar certificado"
            };
        },
        aplicarEndosoState() {
            const validaciones = [
                {   // Status
                    cumple: ["Emitida Pendiente de Pago", "Pagada Parcial", "Pagada Total"].includes(this.poliza?.status),
                    mensaje: "La póliza no se encuentra en status válido para realizar esta acción."
                },
                {   //  No es asistencias
                    cumple: !this.poliza?.asistencias,
                    mensaje: "Asistencias no aplican."
                }
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Aplicar el endoso"
            };
        },
        generarCuotasState() {
            const validaciones = [
                {   //  Status
                    cumple: ["Emitida Pendiente de Pago", "Pagada Parcial"].includes(this.poliza?.status),
                    mensaje: "La póliza no se encuentra en status válido para realizar esta acción."
                },
                {   //  Permisos
                    cumple: this.permisos && this.permisos.includes('FUN_GENERAR_NUEVAMENTE_CUOTAS_EMISIONES_SEGUR'),
                    mensaje: "No cuentas con los permisos necesarios para realizar esta acción."
                }
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Generar cuotas nuevamente"
            };
        },
        reactivarPolizaState() {
            const validaciones = [
                {   //  Status
                    cumple: this.poliza?.status === "Cancelada",
                    mensaje: "La póliza no se encuentra cancelada."
                },
                {   //  Producto Aseg
                    cumple: "Vida-Ahorro" != this.producto?.producto_aseguradora,
                    mensaje: "El producto no permite realizar esta acción."
                },
                {   //  Permisos
                    cumple: this.permisos && this.permisos.includes('FUN_GENERAR_NUEVAMENTE_CUOTAS_EMISIONES_SEGUR'),
                    mensaje: "No cuentas con los permisos necesarios para realizar esta acción."
                },
                {   // Motivo de cancelación
                    cumple: this.poliza?.canceladaFinalizadaMotivo !== "Falta de pago",
                    mensaje: "No se puede reactivar una póliza cancelada por falta de pago."
                },
            ]

            // Si NO es asistencias, validar que no se haya cancelado hace más de 3 meses
            if (!this.poliza?.asistencias) {
                validaciones.push({
                    cumple: moment(new Date(), "DD/MM/YYYY").diff(
                        moment(this.poliza.canceladaDate, "DD/MM/YYYY"),
                        "days"
                    ) < 120,
                    mensaje: "La póliza fue cancelada hace más de 120 días."
                });
            }
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Reactivar póliza"
            };
        },
        cancelarPolizaState() {
            const rolesGenerales = ["ADMIN", "ADMINCUENTA", "OPERADORSERVICIOS", "SUPERVISOR", "COORDINADOR", "GERENTE"];
            const rolesAgentes = ["AGENTCC", "AGENTCCELITE"];
            // Matriz de permisos
            const rolesPermitidosPorEstatus = {
                [getStatusEmisionNombre(0)]: [...rolesGenerales, ...rolesAgentes],
                [getStatusEmisionNombre(1)]: rolesGenerales,
                [getStatusEmisionNombre(2)]: rolesGenerales,
                [getStatusEmisionNombre(3)]: rolesGenerales,
                [getStatusEmisionNombre(8)]: [...rolesGenerales, ...rolesAgentes],
                [getStatusEmisionNombre(9)]: ["ADMIN", "ADMINCUENTA"],
            };
            const rolesPermitidos = rolesPermitidosPorEstatus[this.poliza?.status] || [];
            const validaciones = [
                {   //  Status
                    cumple: this.poliza?.status !== "Cancelada",
                    mensaje: "La póliza ya fue cancelada con anterioridad."
                },
                {   //  Rol es permitido
                    cumple: rolesPermitidos.includes(this.rolName),
                    mensaje: "No tienes permisos para realizar esta acción."
                },
                {   //  Motivo de cancelación
                    cumple: this.poliza?.canceladaFinalizadaMotivo !== null,
                    mensaje: "La póliza ya cuenta con un motivo de cancelación."
                },
            ]
            const error = validaciones.find(v => !v.cumple);

            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Cancelar póliza"
            };
        },
        renovarPolizaState() {
            const validaciones = [
                {   //  Status
                    cumple: ["Emitida Pendiente de Pago", "Pagada Parcial", "Pagada Total", "Cancelada"].includes(this.poliza?.status),
                    mensaje: "La póliza no se encuentra en status válido para realizar esta acción."
                },
                {   //  Rol
                    cumple: ["ADMIN", "GESTORDATOS"].includes(this.rolName),
                    mensaje: "No tienes permisos para realizar esta acción."
                },
                {   //  Producto es renovable (?
                    cumple: this.renovatePolicy === true,
                    mensaje: "El producto no permite renovaciones."
                },
            ]
            const error = validaciones.find(v => !v.cumple);
            return {
                disabled: !!error,
                tooltip: error?.mensaje ?? "Renovar póliza manualmente"
            };
        }
    },
    props: {
        poliza: {
            type: Object
        },
        lead: {
            type: Object
        },
        producto: {
            type: Object
        },
        motivosCancelacion: {
            type: Array,
            default: () => []
        },
        beneficiarios: {
            type: Array,
            default: () => []
        },
        porcentaje: {
            type: Number,
            default: 0
        }
    },
    watch: {
        producto: {
            async handler(newVal) {
                if (newVal) {
                    await this.canRenovate();
                }
            },
            deep: true
        },
    },
    methods: {
        refreshPage() {
            window.location.reload();
        },
        async canRenovate() {
            if (this.producto === null) return;
            const response = await emisionRenovarProductos()
            response.data.forEach((item) => {
                const productoCoincide =
                    this.producto?.producto_aseguradora ==
                    item.producto_aseguradora;
                if (productoCoincide) {
                    const fechaFin = moment(this.poliza.fechaEmision, "YYYY-MM-DD HH:mm:ss")
                        .add(1, "year");
                    const esRenovable = moment().isAfter(fechaFin, "day");
                    if (esRenovable) this.renovatePolicy = true;
                }
            });
        },
        abrirValidarSinCodigoCheck() {
            this.$refs.confirmDialog.open({
                title: "Emitir sin código",
                message: "Antes de emitir asegurate de que todos los datos son correctos",
                action: () => this.$emit('emitirSinCodigo')
            });
        },
        abrirObtenerCertificado() {
            this.$refs.confirmDialog.open({
                title: "Obtener certificado",
                message: "Antes de ejecutar asegurate de que todos los datos son correctos",
                action: () => this.$emit('obtenerCertificado')
            });
        },
        abrirCotizarWs() {
            this.$refs.confirmDialog.open({
                title: "Obtener certificado por WS",
                message: "Antes de ejecutar asegurate de que todos los datos son correctos",
                action: () => this.$emit('obtenerCertificadoWs')
            });
        },
        abrirReenviarCertificado() {
            this.$refs.confirmDialog.open({
                title: "Reenviar certificado",
                message: "¿Seguro?",
                action: () => this.$emit('reenviarCertificado')
            });
        },
        abrirCancelacionEmision() {
            this.$refs.cancelacionDialog.open((motivo, debeMostrarDialog, numeroSms) => {
                if (debeMostrarDialog) {
                    this.motivoCancelacion = motivo;
                    this.showCancelacionDialog = true
                } else {
                    let request = {
                        motivoCancelacion: motivo,
                        numeroSms: numeroSms
                    }
                    this.$emit('cancelarEmision', request);
                }
            });
        },
        abrirAplicarEndoso() {
            this.$refs.aplicarEndosoDialog.open((datosAEnviar) => {
                this.$emit('aplicarEndoso', datosAEnviar);
            });
        },
        abrirRenovacionManual() {
            this.$refs.renovacionManualDialog.open(() => {
                this.$emit('renovacionManual');
            });
        },
        abrirReactivarPoliza() {
            this.$refs.confirmDialog.open({
                title: "Reactivar póliza",
                message: "¿Estás seguro de realizar esta acción?",
                action: () => this.$emit('reactivarPoliza')
            });
        },
        abrirGenerarCuotas() {
            this.$refs.confirmDialog.open({
                title: "Generar cuotas nuevamente",
                message: "¡Atención! Esta acción creara las cuotas nuevamente.",
                action: () => this.$emit('regenerarCuotas')
            });
        },
    },
    async mounted() {
        await this.canRenovate()
    }
}
</script>

<style>
.acciones-grupo-label {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    color: #999;
    margin: 0 0 12px 0;
    letter-spacing: 0.4px;
}

.acciones-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.action-btn {
    justify-content: flex-start;
    text-transform: none;
    font-weight: 500;
}
</style>